/**
 * GA4PageTracker Component
 * 
 * This component wraps the usePageTracking hook and should be mounted
 * at the app root level (inside BrowserRouter) to ensure GA4 page_view
 * events are sent on every route change.
 * 
 * The component itself renders nothing - it only manages the side effect
 * of tracking page views.
 * 
 * Usage:
 *   <BrowserRouter>
 *     <GA4PageTracker />
 *     <Routes />
 *   </BrowserRouter>
 */

import { usePageTracking } from '../../util/usePageTracking';

/**
 * GA4PageTracker component
 * 
 * Mounts the usePageTracking hook to track page views in GA4
 * whenever the route changes in the SPA.
 * 
 * @component
 * @returns {null} This component renders nothing
 */
export const GA4PageTracker = () => {
  // Mount the page tracking hook
  usePageTracking();

  // This component doesn't render anything
  return null;
};

export default GA4PageTracker;
